'use strict';

/**
 * validName – Check if a name is valid.
 * @param {string} value - The name to check.
 * @returns {boolean} - True if the name is valid, false otherwise.
 */
const validName = (value) => {
  return value !== undefined && value.length > 1;
};

/**
 * validEmail – Check if an email is valid.
 * @param {string} value - The email to check.
 * @returns {boolean} - True if the email is valid, false otherwise.
 */
const validEmail = (value) => {
  const emailRegexp =
    /^((([a-z]|\d|[!#$%&'*+\-/=?^_`{|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#$%&'*+\-/=?^_`{|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\\x22)((((\\x20|\\x09)*(\\x0d\\x0a))?(\\x20|\\x09)+)?(([\\x01-\\x08\\x0b\\x0c\\x0e\-\\x1f\\x7f]|\\x21|[\\x23-\\x5b]|[\\x5d\-\\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\\x01-\\x09\\x0b\\x0c\\x0d\-\\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\\x20|\\x09)*(\\x0d\\x0a))?(\\x20|\\x09)+)?(\\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-||_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+([a-z]+|\d|-|\.{0,1}|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])?([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/;
  return emailRegexp.test(value);
};

/**
 * validPhoneNumber – Check if a phone number is valid.
 * @param {string} value - The phone number to check.
 * @returns {boolean} - True if the phone number is valid, false otherwise.
 */
const validPhoneNumber = (value) => {
  const phoneNumberRegexp = /^\+?[0-9]{8,16}$/;
  return phoneNumberRegexp.test(value);
};

/**
 * validContactForm – Check if a contact form is valid.
 * A contact form is valid if name is valid and either or both the phone number or the email is valid.
 * @param {string} name - The name to check.
 * @param {string} email - The email to check.
 * @param {string} phone - The phone number to check.
 * @returns {boolean} - True if the contact form is valid, false otherwise.
 */
exports.validContactForm = (name, email, phone) => {
  if (!validName(name)) {
    return false;
  }

  const isPhoneValid = validPhoneNumber(phone);
  const isEmailValid = validEmail(email);

  if (isPhoneValid && isEmailValid) {
    return true;
  }

  if (isPhoneValid && (email.length === 0 || email === undefined)) {
    return true;
  }

  if (isEmailValid && (phone.length === 0 || phone === undefined)) {
    return true;
  }

  return false;
};
